import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../Styles/Dashboard.css";
import { IMAGES } from "../../utils/images";

const Dashboard = ({ dashDropdown, setDashDropdown }) => {
  const [authenticated, setAuthenticated] = useState(null);
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loggedInUser = sessionStorage.getItem("authenticated");
    if (loggedInUser) {
      setAuthenticated(loggedInUser);

      const userDataStr = localStorage.getItem("user");
      if (userDataStr) {
        try {
          const userData = JSON.parse(userDataStr);
          setUserData(userData);
        } catch (error) {
          console.error("Error parsing user data:", error);
        }
      }
    } else {
      navigate("/signin");
    }
  }, [navigate]);

  const handleLogout = () => {
    sessionStorage.removeItem("authenticated");
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    
    navigate("/signin");
  };

  const isAdmin = userData?.role === 'admin';

  const DashboardTabs = [
    {
      name: "Dashboard",
      link: "/dashboard",
      Icon: IMAGES.DASHBOARD_ICON,
    },
    {
      name: "Courses",
      link: "/dashboard/courses",
      Icon: IMAGES.COURSES_ICON,
    },
    {
      name: "Announcements",
      link: "/dashboard/announcements",
      Icon: IMAGES.ANNOUNCEMENTS_ICON,
    },
    {
      name: "Certificates",
      link: "/dashboard/certificates",
      Icon: IMAGES.CERTIFICATES_ICON,
    },
    {
      name: "Live Sessions",
      link: "/dashboard/livesessions",
      Icon: IMAGES.LIVESESSION_ICON,
    },
    {
      name: "Recorded Classes",
      link: "/dashboard/recordedclasses",
      Icon: IMAGES.RECORDED_ICON,
    },
    {
      name: "Progress",
      link: "/dashboard/progress",
      Icon: IMAGES.PROGRESS_ICON,
    },
    ...(isAdmin ? [
      {
        name: "Contacts",
        link: "/dashboard/contacts",
        Icon: () => (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-2 14H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V8h12v2z"/>
          </svg>
        ),
      }
    ] : []),
  ];

  const pathname = window.location.pathname;

  return (
    <>
    <div className="dashboard-sidebar">
      <ul>
        {DashboardTabs.map((item, index) => {
          return (
            <Link to={item.link} className="link-dash" key={item.name}>
              <li
                className={
                  pathname === item.link ? "side-tab-active" : "side-tab"
                }
              >
                <item.Icon
                  className={
                    pathname === item.link ? "side-icon-active" : "side-icon"
                  }
                />
                {item.name}
              </li>
            </Link>
          );
        })}
      </ul>

      <ul>
        <Link to="/dashboard/feedback" className="link-dash">
          <li
            className={
              pathname === "/dashboard/feedback"
                ? "side-tab-active"
                : "side-tab"
            }
          >
            <IMAGES.FEEDBACK_ICON
              className={
                pathname === "/dashboard/feedback"
                  ? "side-icon-active"
                  : "side-icon"
              }
            />
            Feedback
          </li>
        </Link>
        <Link to="/dashboard/profile" className="link-dash">
          <li
            className={
              pathname === "/dashboard/profile" ? "side-tab-active" : "side-tab"
            }
          >
            <IMAGES.ACCOUNT_ICON
              className={
                pathname === "/dashboard/profile"
                  ? "side-icon-active"
                  : "side-icon"
              }
            />
            Profile
            {userData && (
              <span className="user-name-display" style={{ fontSize: '12px', marginLeft: '5px', color: '#666' }}>
                ({userData.fullName})
              </span>
            )}
          </li>
        </Link>
        <li 
          className="side-tab" 
          onClick={handleLogout}
          style={{ cursor: 'pointer' }}
        >
          <IMAGES.LOGOUT_ICON className="side-icon" />
          Logout
        </li>
      </ul>
    </div>
    <div className={dashDropdown ? "dashboard-sidebar-mobile-active":"dashboard-sidebar-mobile"}>
      <ul>
        {DashboardTabs.map((item, index) => {
          return (
            <Link to={item.link} className="link-dash" key={item.name} onClick={setDashDropdown}>
              <li
                className={
                  pathname === item.link ? "side-tab-active" : "side-tab"
                }
              >
                <item.Icon
                  className={
                    pathname === item.link ? "side-icon-active" : "side-icon"
                  }
                />
                {item.name}
              </li>
            </Link>
          );
        })}
      </ul>

      <ul>
        <Link to="/dashboard/feedback" className="link-dash" onClick={setDashDropdown}>
          <li
            className={
              pathname === "/dashboard/feedback"
                ? "side-tab-active"
                : "side-tab"
            }
          >
            <IMAGES.FEEDBACK_ICON
              className={
                pathname === "/dashboard/feedback"
                  ? "side-icon-active"
                  : "side-icon"
              }
            />
            Feedback
          </li>
        </Link>
        <Link to="/dashboard/profile" className="link-dash" onClick={setDashDropdown}>
          <li
            className={
              pathname === "/dashboard/profile" ? "side-tab-active" : "side-tab"
            }
          >
            <IMAGES.ACCOUNT_ICON
              className={
                pathname === "/dashboard/profile"
                  ? "side-icon-active"
                  : "side-icon"
              }
            />
            Profile
            {userData && (
              <span className="user-name-display" style={{ fontSize: '12px', marginLeft: '5px', color: '#666' }}>
                ({userData.fullName})
              </span>
            )}
          </li>
        </Link>
        <li 
          className="side-tab" 
          onClick={handleLogout}
          style={{ cursor: 'pointer' }}
        >
          <IMAGES.LOGOUT_ICON className="side-icon" />
          Logout
        </li>
      </ul>
    </div>
    </>
  );
};

export default Dashboard;
